import React from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react-text';
import { Button } from '@paypalcorp/pp-react-buttons';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { ConfirmedIllustration } from './components/Illustration';
import { spinnerOpen } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { redirectFlowAction } from '../../../framework/store/RedirectFlow/RedirectFlowActions';
import { REDIRECT_SUFFIX } from '../../config/pageNames';
import { CaptionText } from './components/CaptionText';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';

import './ConfirmationPage.less';

const LOCALE_PREFIX = 'US/pages/AppPendPage/ConfirmationPage';

export const ConfirmationPage = ({ isPayInFullNowAvailable, isExistingPayPalUser, doneRedirect, isTransactionalFlow, appUnderReview, initialRender }) => {

    React.useEffect(() => {
        initialRender();
    }, []);

    const handleClick = () => {
        const cancelUrl = isPayInFullNowAvailable && isExistingPayPalUser ? REDIRECT_SUFFIX.PAY_IN_FULL_REDIRECT : REDIRECT_SUFFIX.CANCEL_REDIRECT;
        doneRedirect(cancelUrl);
    };

    const subheaderText = `${LOCALE_PREFIX}.subheader`;
    let headerText = `${LOCALE_PREFIX}.header`;
    let buttonText = `${LOCALE_PREFIX}.btnText`;
    let captionTextOne = '';
    let captionTextTwo = '';

    if (appUnderReview) {
        headerText = `${LOCALE_PREFIX}.appUnderReview.header`;
        captionTextOne = `${LOCALE_PREFIX}.appUnderReview.captionText1`;
        captionTextTwo = `${LOCALE_PREFIX}.appUnderReview.captionText2`;
    } else if (isTransactionalFlow) {
        captionTextOne = `${LOCALE_PREFIX}.checkout.captionText1`;
        captionTextTwo = `${LOCALE_PREFIX}.checkout.captionText2`;
        buttonText = `${LOCALE_PREFIX}.checkout.btnText`;
    }

    return (
        <div className="confirmationContainer">
            <HeadingText className="confirmationHeading" size="md">
                <FormattedMessage id={headerText} />
            </HeadingText>
            <div className="confirmationPageIcon"><ConfirmedIllustration /></div>
            {(isTransactionalFlow || appUnderReview) ?
                <>
                    <CaptionText className="confirmationSubtext" text={captionTextOne} />
                    <CaptionText className="confirmationSubtext" text={captionTextTwo} />
                </> 
                : <CaptionText className="confirmationSubtext" text={subheaderText} />
            }
            <Button onClick={handleClick} className="confirmationPageActionButton">
                <FormattedMessage id={buttonText} />
            </Button>
        </div>
    );
};

ConfirmationPage.propTypes = {
    isPayInFullNowAvailable: PropTypes.bool,
    isExistingPayPalUser: PropTypes.bool,
    doneRedirect: PropTypes.func.isRequired,
    isTransactionalFlow: PropTypes.bool.isRequired,
    appUnderReview: PropTypes.bool.isRequired,
    initialRender: PropTypes.func.isRequired
};

export const mapStateToProps = state => ({
    isPayInFullNowAvailable: get(state, 'serverData.isPayInFullNowAvailable'),
    isExistingPayPalUser: get(state, 'serverData.isExistingPayPalUser')
});

export const mapDispatchToProps = dispatch => ({
    initialRender() {
        dispatch(trackTransition('apply_pp_credit_confirmationPage', 'prepare_pp_credit_confirmationPage'));
    },
    doneRedirect(actionUri) {
        dispatch(trackTransition('apply_pp_credit_confirmationPage', 'process_pp_credit_confirmationPage'));
        dispatch(spinnerOpen());
        dispatch(redirectFlowAction(actionUri));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationPage);
